<div class="grid-wrapper">
  <div class="grid">
    <!-- TOP BAR FILTER -->
    <div class="main-filter" style="text-align: center">
      <div class="row" id="header-row">
        <div class="col-8" id="daterange">
          <frm-daterange-picker
            [formGroup]="filterRangeCtl"
            orientation="horizontal"
            formControlNameRangeBegin="start"
            formControlNameRangeEnd="end"
          ></frm-daterange-picker>
        </div>
        <div class="col-4">
          <div [formGroup]="filterAnlageCtl">
            <frm-anlage-facility-no-select
              formControlName="anlage"
              (facilitySelected)="OnAnlageSelect($event)"
              i18n-label="@@PlanungApi_Overview_FilterAnlageNr_Search"
              label="Select facility no."
            ></frm-anlage-facility-no-select>
          </div>
        </div>
      </div>
    </div>

    <!-- UNASSIGNED TASKS -->
    <div class="tasks-unassigned unassign-drop-target">
      <div
        class="unassigned-title k-header"
        style="vertical-align: middle; text-align: center"
      >
        <b i18n="@@PlanungApi_Overview_Unassigned_Title"
          >Tasks without a date</b
        >
        <hr style="margin-top: 2px" />
      </div>

      <!-- FILTER -->
      <div class="unassigned-filter">
        <div class="row">
          <div class="col">
            <frm-text
              [(ngModel)]="filterUnassigned.TaskNoText"
              label="Search for tasks (no. and text)"
              i18n-label="@@PlanungApi_Overview_FilterAnlageNr"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-expansion-panel id="filter-expander">
              <mat-expansion-panel-header>
                <mat-panel-title i18n="@@PlanungApi_Overview_FilterExpander">
                  Other filters...
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col">
                  <frm-planung-resource-select
                    [multiselect]="true"
                    [(ngModel)]="filterUnassigned.Resources"
                    [resources]="resources$ | async"
                    [allowNone]="false"
                  >
                  </frm-planung-resource-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <frm-planung-task-category-select
                    [multiselect]="true"
                    [(ngModel)]="filterUnassigned.Categories"
                  ></frm-planung-task-category-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-task-status-droplist
                    [(ngModel)]="filterUnassigned.TaskStatus"
                    [forFilter]="true"
                    i18n-label="@@PlanungApi_Overview_FilterSelectTaskStatus"
                    label="Select a task status"
                    width="100%"
                  ></app-task-status-droplist>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
      </div>

      <!-- LIST -->
      <div class="unassigned-list">
        <app-planung-task-drag-drop-list
          class="unassigned-drop-area"
          [overview]="this"
          [tasks]="TasksUnassigned | async"
          [taskDragDropListItemTemplate]="taskDragDropListItemTemplate"
          (tasksDropped)="TaskUnassign($event)"
        >
          <ng-template #taskDragDropListItemTemplate let-item="item">
            <app-planung-task-card
              [task]="item"
              [resources]="resources"
              [taskStateMetas]="taskStateMetas"
              [handlesDragDrop]="false"
              [showTooltip]="uiState.ShowTaskCardTooltips"
              (contextmenu)="onRightClick($event)"
            >
            </app-planung-task-card>
          </ng-template>
        </app-planung-task-drag-drop-list>
        <app-spinner-overlay [visible]="isLoading | async">
        </app-spinner-overlay>
      </div>
    </div>

    <!-- ASSIGNED TASKS -->
    <div class="tasks-assigned">
      <!-- FILTER -->
      <div class="assigned-filter">
        <div class="row">
          <div class="col">
            <frm-text
              i18n-label="@@PlanungApi_Overview_FilterAnlageNr"
              label="Search for tasks (no. and text)"
              [(ngModel)]="filter.TaskNoText"
            ></frm-text>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6">
            <frm-check
              [(ngModel)]="uiState.CalendarGroupingActive"
              i18n-label="@@PlanungApi_Overview_GroupByResources"
              label="Group tasks by user / groups"
            ></frm-check>
          </div>
          <div class="col-sm-12 col-md-6">
            <frm-check
              [(ngModel)]="uiState.ShowTaskCardTooltips"
              i18n-label="@@PlanungApi_Overview_ShowTaskCardTooltips"
              label="Show card tooltips"
            ></frm-check>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <frm-check
              [(ngModel)]="uiState.HideTasksForOverview"
              i18n-label="@@PlanungApi_Overview_HideTasksForOverview"
              label="Hide tasks for a better overview"
            ></frm-check>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <mat-expansion-panel id="filter-expander">
              <mat-expansion-panel-header>
                <mat-panel-title i18n="@@PlanungApi_Overview_FilterExpander">
                  Other filters...
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col">
                  <frm-planung-resource-select
                    [multiselect]="true"
                    [(ngModel)]="filter.Resources"
                    [resources]="resources"
                    [allowNone]="false"
                  >
                  </frm-planung-resource-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <frm-planung-task-category-select
                    [multiselect]="true"
                    [(ngModel)]="filter.Categories"
                  ></frm-planung-task-category-select>
                </div>
                <div class="col">
                  <app-task-status-droplist
                    [isMultiselect]
                    [(ngModel)]="filter.TaskStatus"
                    [forFilter]="true"
                    i18n-label="@@PlanungApi_Overview_FilterSelectTaskStatus"
                    label="Select a task status"
                    width="calc(100%)"
                  ></app-task-status-droplist>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
      </div>

      <!-- LIST -->
      <div class="assigned-tabsheet">
        <mat-tab-group
          mat-align-tabs="center"
          (selectedTabChange)="onPlanungTabSelected($event)"
        >
          <mat-tab i18n-label="@@PlanungAPI_Overview_TabMonths" label="Months">
            <ng-template matTabContent>
              <app-planung-number-tasks-collection
                [overview]="this"
                [items]="TasksMonths"
              >
              </app-planung-number-tasks-collection>
            </ng-template>
          </mat-tab>
          <mat-tab
            i18n-label="@@PlanungAPI_Overview_TabCalendarWeeks"
            label="Calendar Weeks"
          >
            <ng-template matTabContent>
              <app-planung-number-tasks-collection
                [overview]="this"
                [items]="TasksCalendarWeeks"
              >
              </app-planung-number-tasks-collection>
            </ng-template>
          </mat-tab>
          <mat-tab
            i18n-label="@@PlanungAPI_Overview_TabDayView"
            label="Day View"
          >
            <ng-template matTabContent>
              <app-planung-scheduler-dayview
                [overview]="this"
              ></app-planung-scheduler-dayview>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
        <app-spinner-overlay [visible]="isLoading | async">
        </app-spinner-overlay>
      </div>
    </div>
  </div>
</div>

<app-material-context-menu #taskContextMenu [items]="currentMenuActions">
</app-material-context-menu>
